<template>
    <div>
      
    </div>
  </template>
  
  <script>

  export default {
   
    data() {
      return {
        coresList: [
          {
            tit: '',
            isActive: true,
          },
          {
            tit: '',
            isActive: false,
          },
          {
            tit: '',
            isActive: false,
          },
        ],
        currentIndex: 0,
       
      }
    },
    
    created() {  
          // 获取 URL 中的 code 参数  
          const urlParams = new URLSearchParams(window.location.search);  
          const code = urlParams.get('code');  
          const state = urlParams.get('state'); // 如果需要使用 state 参数  
  console.log(code,state,'1111111111111111111111111111');
          if (code!=null) {  
          // 将 code 发送到父页面  
          window.parent.postMessage({  
              cmd: 'returnFormJson',  
              params: {  
                  QR_code: { code, state }  
              }  
          }, '*');  
        }
      } ,
  
  }
  </script>
  
  <style lang="scss" scoped>
  
  </style>